import { render, staticRenderFns } from "./Keuntungan.vue?vue&type=template&id=db9efd98&scoped=true"
import script from "./Keuntungan.vue?vue&type=script&lang=js"
export * from "./Keuntungan.vue?vue&type=script&lang=js"
import style0 from "./Keuntungan.vue?vue&type=style&index=0&id=db9efd98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db9efd98",
  null
  
)

export default component.exports